"use client";

import { ArrowRight, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultation() {
  const leftReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.12
  });
  const rightReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.12
  });
  const tiers = [{
    name: "Initial Audit",
    description: "project scope",
    priceLabel: "\n"
  }, {
    name: "Strategic Roadmap",
    description: "full implementation",
    priceLabel: "\n"
  }, {
    name: "Stamped Engineer Reports",
    description: "and much more",
    priceLabel: "\n"
  }];
  return <section data-section-id="15712" id="ready-to-discuss-your-project" className="bg-background text-foreground py-28 md:py-40 px-5 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={leftReveal.ref} className={`lg:col-span-7 transition-all duration-[640ms] ease-out ${leftReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            {}
            <div className={`transition-all duration-[640ms] ease-out ${leftReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: leftReveal.isVisible ? "0ms" : "0ms"
          }}>
              <p className="font-default text-xs font-semibold uppercase text-foreground/70" style={{
              letterSpacing: "0.14em"
            }}>
                For Business Growth
              </p>
              <div className="mt-3 h-px w-12 bg-foreground/40" />
            </div>

            {}
            <h2 className={`mt-8 font-default text-foreground transition-all duration-[640ms] ease-out ${leftReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(2rem, 3.6vw, 3.25rem)",
            fontWeight: 600,
            letterSpacing: "-0.018em",
            lineHeight: 1.08,
            transitionDelay: leftReveal.isVisible ? "80ms" : "0ms"
          }}>
              Transform your business with{" "}
              <em className="font-default" style={{
              fontStyle: "italic",
              fontWeight: 600,
              color: "hsl(210 100% 50%)"
            }}>
                expert
              </em>
              , tailored strategy.
            </h2>

            {}
            <p className={`mt-7 font-default text-foreground/80 max-w-[52ch] transition-all duration-[640ms] ease-out ${leftReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
            fontWeight: 400,
            letterSpacing: "-0.003em",
            lineHeight: 1.62,
            transitionDelay: leftReveal.isVisible ? "160ms" : "0ms"
          }}>
              Our consulting services provide the clarity and roadmap needed to scale your operations effectively. From initial audits to long-term strategic partnerships, we help you navigate complex challenges with data-driven insights and proven methodologies that deliver measurable results.
            </p>

            {}
            <div className={`mt-10 flex flex-col sm:flex-row sm:items-center gap-6 transition-all duration-[640ms] ease-out ${leftReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: leftReveal.isVisible ? "240ms" : "0ms"
          }}>
              <Button asChild className="rounded-lg px-7 py-3.5 h-auto font-default text-sm font-medium text-primary-foreground hover:opacity-90 shadow-md" style={{
              backgroundColor: "hsl(240 100% 25%)"
            }}>
                <Link to="/ServicesPage">
                  View Our Services
                </Link>
              </Button>

              <Link to="/ContactPage" className="group inline-flex items-center gap-2 font-default text-foreground hover:text-foreground/90 transition-colors" style={{
              fontWeight: 500
            }}>
                
                
                
              </Link>
            </div>
          </div>

          {}
          <div ref={rightReveal.ref} className={`lg:col-span-5 transition-opacity duration-[640ms] ease-out ${rightReveal.isVisible ? "opacity-100" : "opacity-0"}`}>
            <div className="rounded-lg border border-border p-8 bg-card shadow-lg">
              <p className="font-default text-xs font-semibold uppercase text-foreground/70 mb-2" style={{
              letterSpacing: "0.14em"
            }}>HOW WE CAN HELP</p>
              <div className="h-px w-12 bg-primary mb-8" />

              <div className="flex flex-col">
                {tiers.map((tier, i) => <div key={i} data-index={i} className={`flex items-start justify-between gap-4 py-5 ${i !== tiers.length - 1 ? "border-b border-border" : ""} ${i === 0 ? "pt-0" : ""}`}>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-default text-foreground" style={{
                    fontSize: "clamp(1rem, 1.1vw, 1.125rem)",
                    fontWeight: 600,
                    letterSpacing: "-0.005em",
                    lineHeight: 1.35
                  }}>
                        {tier.name}
                      </h3>
                      <p className="mt-1 font-default text-muted-foreground" style={{
                    fontSize: "0.8125rem",
                    fontWeight: 400,
                    letterSpacing: "0.005em",
                    lineHeight: 1.45
                  }}>
                        {tier.description}
                      </p>
                    </div>
                    <div className="font-mono text-right shrink-0" style={{
                  color: "hsl(240 100% 25%)",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  letterSpacing: "-0.01em",
                  lineHeight: 1.4
                }}>
                      {tier.priceLabel}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}